<template>
  <base-data-table
    :items="consultationServiceHistories"
    title="相談サービス利用履歴"
    header-icon="mdi-account-clock-outline"
    scrollable
    scroll-height="600px"
    :column-widths="['150px', '140px', '160px', '160px', '160px', '', '', '170px']"
  >
    <template #header-cells>
      <th>日時</th>
      <th>サービス種類</th>
      <th>相談対象の子</th>
      <th>相談対象の子の生年月日</th>
      <th>出産予定日/最後の出産日</th>
      <th>主訴</th>
      <th>暫定診断</th>
      <th />
    </template>
    <template #cells="{ row: consultationHistory }">
      <td>{{ consultationHistory.consultedAt }}</td>
      <td>
        {{ consultationHistory.serviceType }}<br>
        {{ consultationHistory.department }}
      </td>
      <td>
        {{ consultationHistory.childName }}<br>
        ID: {{ consultationHistory.childId }}
      </td>
      <td>
        {{ consultationHistory.childBirthday }}<br>
        {{ consultationHistory.childAgeAtConsultation }}
      </td>
      <td>{{ consultationHistory.dueDate }}</td>
      <td>
        <div class="base-data-table-two-line-clamp">
          {{ consultationHistory.mainComplaint }}
        </div>
      </td>
      <td>
        <div class="base-data-table-two-line-clamp">
          {{ consultationHistory.provisionalDiagnosis }}
        </div>
      </td>
      <td class="base-data-table-action-cell">
        <v-btn
          color="#3ACAC9"
          variant="outlined"
          size="small"
          prepend-icon="mdi-open-in-new"
          @click="$emit('open-karte', consultationHistory)"
        >
          相談カルテを開く
        </v-btn>
      </td>
    </template>
  </base-data-table>
</template>

<script>
import BaseDataTable from "./BaseDataTable.vue";

export default {
  name: "FaceSheetConsultationServiceHistoryTable",
  components: {
    BaseDataTable
  },
  props: {
    consultationServiceHistories: {
      type: Array,
      default: () => []
    }
  },
  emits: ["open-karte"]
};
</script>
